// @ts-nocheck
import { initialState } from "./reducer";

const snack = (state) => state["organisms/snackPortal"] || initialState;

export const getSnacks = (state) => snack(state)["snacksList"];
